import { motion } from "framer-motion";

const MotionDiv = ({ children,
  initial = { opacity: 0 },
  animate = { opacity: 1 },
  exit = { opacity: 0 },
  transition = { duration: .2 },
  origin = 'none',
  className = 'mdn'
}
) => {

  return (
    <motion.div
      initial={initial}
      animate={animate}
      exit={exit}
      transition={transition}
      className={className || null}
    >
      {children}
    </motion.div>
  );
};

export const FadeWrapper = ({ children }) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: .3 }}
    >
      {children}
    </motion.div>
  );
};

export default MotionDiv; 